export const ROUTE_ARRAY = [
  {
    routePath: '/admin-authorized',
    eventName: 'Routed_to_AdminAuthorized_page',
    params: {},
  },
  {
    routePath: '/dashboard',
    eventName: 'Routed_to_Dashboard_page',
    params: {},
  },
  {
    routePath: '/analytics',
    eventName: 'Analytics_viewed',
    params: {},
  },
  {
    routePath: '/my-orders',
    eventName: 'Orders_Selected',
    params: {},
  },
  {
    routePath: '/catalogue',
    eventName: 'Catalog_viewed',
    params: {},
  },
  {
    routePath: '/vendor-details',
    eventName: 'Seller_profile_selected',
    params: {},
  },
  {
    routePath: '/orders',
    eventName: 'Routed_to_admin_orders_page',
    params: {},
  },
  {
    routePath: '/payments',
    eventName: 'Order_Passbook_Selected',
    params: {},
  },
  // {
  //   routePath: 'user/seller/logout',
  //   eventName: 'Seller_logout',
  //   params: { eventName: 'Seller_logout' },
  // },
  {
    routePath: '/bulk-deals',
    eventName: 'Bulk_Deal_selected',
    params: {},
  },
  {
    routePath: '/reverse-auction',
    eventName: 'Big_Deal_selected',
    params: {},
  },
  {
    routePath: '/payments-history',
    eventName: 'Payments_Ledger_Selected',
    params: {},
  },
  {
    routePath: '/nic-credentials',
    eventName: 'API_credentials_viewed',
    params: {},
  },
];
